import { combineReducers } from "redux";
import sessions from "./sessions.reducer";
import status from "./status.reducer";
import search from "./search.reducer";
import schedule from "./schedule.reducer";
import suspend from "./suspend.reducer";
import scheduleModal from "./scheduleModal.reducer";
import suspendModal from "./suspendModal.reducer";
import upcommingSessions from "./upcommingSessions.reducer";
import reviewModal from "./reviewModal.reducer";
import openSession from "./openSession.reducer";
import review from "./review.reducer";
import sessionsFilter from "./sessionsFilter.reducer";

export default combineReducers({
  upcommingSessions,
  sessionsFilter,
  scheduleModal,
  suspendModal,
  reviewModal,
  openSession,
  schedule,
  suspend,
  sessions,
  review,
  status,
  search,
});
